// @flow
// $FlowFixMe
import React, { useRef } from 'react';
import classnames from 'classnames';

import LoadingIndicator from '../common/LoadingIndicator';

import styles from './PaymentFormSubmitButton.css';
import Subscribe from '../messages/Subscribe';
import { FormattedMessage } from 'react-intl';

type OwnProps = {
  isLoading: boolean,
  isTrialAvailable: boolean,
  trialDurationDays: number,
  isValentine26Campaign: boolean,
};

type Props = OwnProps;

const PaymentFormSubmitButton = ({
  isLoading,
  isTrialAvailable,
  trialDurationDays,
  isValentine26Campaign,
}: Props) => {
  const buttonRef = useRef(null);

  const buttonClassName = classnames('c-btn c-btn--is-inverted', styles.button, {
    [styles.isLoading]: isLoading,
  });

  const ButtonText = () => {
    if (isValentine26Campaign) {
      return (
        <FormattedMessage
          id="premium.payment-form.submit-btn.valentine26"
          defaultMessage="Try it for {trialDurationMonths} months"
          values={{ trialDurationMonths: Math.ceil(trialDurationDays / 30) }}
        />
      );
    }
    if (isTrialAvailable) {
      return (
        <FormattedMessage
          id="premium.payment-form.submit-btn.start-my-trial"
          defaultMessage="Start my {trialDurationDays}-day free trial"
          values={{ trialDurationDays }}
        />
      );
    }
    return <Subscribe />;
  };

  return (
    <React.Fragment>
      <button
        className={buttonClassName}
        disabled={isLoading}
        ref={buttonRef}
        data-test="payment-form.submit-btn"
        type="submit"
      >
        <LoadingIndicator isLoading={isLoading} className={styles.loader} />
        <span className="payment-form__button-text">
          <ButtonText />
        </span>
      </button>
    </React.Fragment>
  );
};

export default PaymentFormSubmitButton;
